
import { UnloadService } from "@share/common/services/unloadService/UnloadService";
import { Vue, Component } from "vue-property-decorator";

@Component({})

export default class Resetable extends Vue {
    unloadService: UnloadService | null = null;

    resetable = false;

    created() {
        this.unloadService = new UnloadService(this, "resetable", this.$t('agenda.form.goBackConfirmation').toString());
    }
}
